export default __webpack_public_path__ + "static/media/02.0d8e4dd8.jpg";